module.exports = __webpack_public_path__ + "media/images/avatar_menu-cf36f43d1cac8bf42cb037432d4de376.svg";